import axios from 'axios'
import Cookies from 'js-cookie'
import system from './system'
import activity from './activity'
import weixin from './weixin'
import lisfHall from './lifeHall'
import { apiBaseUrl, commonApi, wechatApi } from '../config/index'

const TIME_OUT = 10000
// 实例化 ajax请求对象
const ajaxinstance = axios.create({
  baseURL: apiBaseUrl.path,
  timeout: TIME_OUT,
  headers: {
    responseType: 'json',
    'Content-Type': 'application/json; charset=utf-8',
    // 'Content-Type': 'application/x-www-form-urlencoded'
  },
})

// 添加拦截器，处理 公用请求参数，和通用请求头部
ajaxinstance.interceptors.request.use(
  (config) => {
    // TODO
    // console.log(config)
    const tp = Cookies.get('top_session')
    if (tp) {
      config.headers.topsession = tp
    }
    try {
      let userInfo = window.sessionStorage.USER_INFO
      if (userInfo) {
        userInfo = JSON.parse(userInfo)
        console.log(userInfo)
        config.headers['user-code'] = userInfo.userCode || ''
      }
    } catch (err) {
      console.error(err)
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  },
)

// 请求响应拦截器
ajaxinstance.interceptors.response.use(
  (response) => {
    // TODO 需要重新定义
    const { data } = response
    return data
  },
  error => Promise.reject(error),
)

// 实例化 ajax请求对象
const commonAjaxinstance = axios.create({
  baseURL: commonApi.path,
  timeout: TIME_OUT,
  headers: {
    responseType: 'json',
    'Content-Type': 'application/json; charset=utf-8',
    // 'Content-Type': 'application/x-www-form-urlencoded'
  },
})
// 请求响应拦截器
commonAjaxinstance.interceptors.response.use(
  (response) => {
    const { data } = response
    return data
  },
  error => Promise.reject(error),
)

// 实例化 ajax请求对象
const wechatAjaxinstance = axios.create({
  baseURL: wechatApi.path,
  timeout: TIME_OUT,
  headers: {
    responseType: 'json',
    'Content-Type': 'application/json; charset=utf-8',
    // 'Content-Type': 'application/x-www-form-urlencoded'
  },
})
// 请求响应拦截器
wechatAjaxinstance.interceptors.response.use(
  (response) => {
    const { data } = response
    return data
  },
  error => Promise.reject(error),
)

/**
 * [API api接口封装]
 * @type {Object}
 */
const API = {
  ...system(commonAjaxinstance),
  ...activity(ajaxinstance),
  ...weixin(wechatAjaxinstance),
  ...lisfHall(ajaxinstance),
}

export default API
